import { doc, getDocFromServer, setDoc } from 'firebase/firestore';

export async function saveUserProfile({ auth, firestore, account, changes, completing = false }) {
  const assertSession = () => {
    if (!account || account.isAnonymous || auth.currentUser?.uid !== account.uid) {
      throw Object.assign(new Error('Please sign in again before saving your profile.'), { code: 'auth/session-changed' });
    }
  };
  assertSession();
  const ref = doc(firestore, 'users', account.uid);
  const snapshot = await getDocFromServer(ref);
  assertSession();
  if (!completing && !snapshot.exists()) {
    throw new Error('Your profile is missing. Reload to complete your profile.');
  }
  const existing = snapshot.exists() ? snapshot.data() : {};
  const data = { ...changes };
  // These fields describe the session; they must never be persisted as proof of login.
  ['isAuthenticated', 'isLoading', 'id', 'email', 'createdAt'].forEach(key => delete data[key]);
  Object.keys(data).forEach(key => data[key] === undefined && delete data[key]);
  if (data.role || data.practitionerType) {
    data.role = data.role || data.practitionerType;
    data.practitionerType = data.role;
  }
  const saved = {
    ...data,
    id: account.uid,
    email: account.email || '',
    updatedAt: new Date().toISOString(),
    ...(!snapshot.exists() ? { createdAt: new Date().toISOString() } : {})
  };
  // A partial recovery must preserve existing education, progress, preferences, etc.
  await setDoc(ref, saved, { merge: true });
  assertSession();
  return { ...existing, ...saved };
}
